import styled from '@xstyled/styled-components';

/** Instructions occupy their own row, so they cannot cover required controls. */
export const HotspotInstructions = styled.h1`
  position: relative;
  flex-shrink: 0;
  align-self: center;
  max-width: calc(100% - 32px);
  margin: 0 16px 12px;
  padding: 7px 25px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: inherit;
  font-weight: 400;
  line-height: inherit;
  overflow-wrap: anywhere;
`;
